.se-container-wide {
  max-width: 1200px;
  margin-left: auto;
  margin-right: auto;
  padding-left: 15px;
  padding-right: 15px;
}

@media screen and (min-width: 980px) {
  .se-container-wide {
    padding-left: 10px;
    padding-right: 10px;
  }
}

:host {
  background-color: #ffffff;
}

@media screen and (max-width: 979px) {
  .environmental__data {
    display: block;
  }
}

@media screen and (min-width: 980px) {
  .section {
    padding: 56px 10px 72px;
    max-width: 1200px;
    margin: 0 auto;
    margin-bottom: 8px;
  }
}

.environmental__data__section--primary {
  display: flex;
  align-items: flex-start;
  font-family: "ArialRoundedMTforSE", sans-serif;
}

@media screen and (max-width: 979px) {
  .environmental__data__section--primary {
    flex-direction: column;
  }
}

@media screen and (min-width: 980px) {
  .environmental__link {
    margin-bottom: 16px;
  }
}

:host([dir=rtl]) .environment__tooltip-trigger {
  margin: 2px;
}

.environment__tooltip-trigger {
  margin: 5px;
}